import { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { Link, useNavigate } from 'react-router-dom';
import ApiService from '@/services/api';
import dayjs from 'dayjs';
import TrialBalanceTable from './table';

const TrialBalance = () => {
  const navigate = useNavigate();
  const [report, setReport] = useState({ items: [], cooperative_name: '' });
  const [loading, setLoading] = useState(true);
  const [cooperative, setCooperative] = useState(null);

  const [filters, setFilters] = useState({
    date: dayjs().format("YYYY-MM-DD"),
  });

  // Load data on component mount
  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const profile = JSON.parse(localStorage.getItem("user_profile"));
      const cooperativeId = profile?.cooperative.id || 0;
      setCooperative(profile?.cooperative);

      const response = await ApiService.getTrialBalanceComplete(
        cooperativeId,
        filters.date
      );

      if (response.status === 200) {
        setReport(response.data || { items: [], cooperative_name: '' });
      }
    } catch (error) {
      console.error(error);
      setReport({ items: [], cooperative_name: '' });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        @media print {
          nav, .card-header, .no-print { display: none !important; }
          .card { box-shadow: none !important; border: none !important; }
          body { background: white !important; }
          thead { background: #1e3a8a !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        }
      `}</style>
      
      <nav className="flex mb-6 no-print" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-3">
          <li className="inline-flex items-center">
            <Link
              to="/dashboard"
              className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600"
            >
              <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
              </svg>
              Dashboard
            </Link>
          </li>
          <li>
            <div className="flex items-center">
              <svg className="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"></path>
              </svg>
              <button
                className="ml-1 text-sm font-medium text-gray-700 hover:text-blue-600 md:ml-2"
              >
                Neraca Saldo
              </button>
            </div>
          </li>
        </ol>
      </nav>
    
      <div className="flex flex-auto flex-col">
        <div className="card">
          <div className="card-header">
            <div className="flex justify-between items-center">
              <h4 className="card-title">Neraca Saldo</h4>
              <div className="flex gap-2">
                <input
                  type="date"
                  value={filters.date}
                  onChange={(e) =>
                    setFilters({ ...filters, date: e.target.value })
                  }
                  className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-sm"
                />
                <button
                  className="btn bg-blue-600 text-white px-4 py-2 rounded"
                  onClick={() => loadData()}
                  disabled={loading}
                >
                  <i className="mgc_search_line me-2"></i>Filter
                </button>
                <button
                  className="btn btn-sm bg-secondary text-white"
                  onClick={() => loadData()}
                  disabled={loading}
                >
                  <i className="mgc_refresh_1_line me-2"></i>Refresh
                </button>
                <button
                  className="btn btn-sm bg-success text-white"
                  onClick={() => window.print()}
                >
                  <i className="mgc_print_line me-2"></i>Print
                </button>
              </div>
            </div>
          </div>
          
          <div className="p-6">
            {/* Header Koperasi */}
            {cooperative && (
              <div className="text-center mb-6 print:block">
                <h2 className="text-xl font-bold">{cooperative.name}</h2>
                <div className="mt-4">
                  <h3 className="text-lg font-bold">Neraca Saldo</h3>
                  <p className="text-sm">per {dayjs(filters.date).format('DD MMMM YYYY')}</p>
                </div>
              </div>
            )}

            <div className="overflow-x-auto">
              {loading ? (
                <div className="text-center py-8">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              ) : (
                <TrialBalanceTable 
                  data={report.items || []} 
                  totalDebits={report.total_debits || 0}
                  totalCredits={report.total_credits || 0}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TrialBalance;
